<template>
    <div>
        <div class="app-body">
            <page-header></page-header>
            <div class="allContain xy-between">
                <nav-bar ref="navBarLeft"></nav-bar>
                <div class="accountSet">
                    <div class="tit font-size16 jf">
                        <div class="btns yx-between" @click="basicInfo">
                            <div>基本信息</div>
                            <div
                                v-if="navigationActive === 'info'"
                                class="tab"
                            ></div>
                        </div>

                        <div class="btns yx-between" @click="bindOrgan">
                            <div>机构绑定</div>
                            <div
                                v-if="navigationActive === 'organ'"
                                class="tab"
                            ></div>
                        </div>
                    </div>
                    <div>
                        <!--个人基本信息-->
                        <div
                            v-if="navigationActive === 'info'"
                            class="information"
                        >
                            <personInfo
                                @updataPersonInfo="updataInfo"
                            ></personInfo>
                        </div>
                        <!--个人基本信息-->

                        <!-- 绑定机构 -->
                        <div
                            v-if="navigationActive === 'organ'"
                            class="information"
                        >
                            <bindOrgan></bindOrgan>
                        </div>
                        <!-- 绑定机构 -->
                    </div>
                </div>
            </div>
        </div>
        <bottom-ground></bottom-ground>
    </div>
</template>

<script>
import PageHeader from "@/components/header";
import NavBar from "@/components/personCenter/nav";
import BottomGround from "@/components/bottomnav";
import personInfo from "@/components/basicInfo/personInfo";
import bindOrgan from "@/components/basicInfo/bindOrgan";
import {
    UserInfo,
    EditUser,
    UserOrganLevelApply,
    UpdateTelphoneSendMsg,
    VerifyOldTelphone,
    BindTelphoneSendMsg,
    BindTelphone
} from "@/api/user";
import { GetOrganInfoByKeyword, GetOrganLevelInfo } from "@/api/organ";

export default {
    components: {
        PageHeader,
        NavBar,
        BottomGround,
        personInfo,
        bindOrgan
    },
    created() {
        this.getUserInfo();
    },
    data() {
        return {
            currentNav: "personInfo",
            navigationActive: "info",
            // 用户表单
            userForm: {
                ID: "",
                UserName: "",
                RealName: "",
                Sex: 1,
                Telephone: "",
                Email: "",
                Address: "",
                CardId: "",
                NumberNo: "",
                DescInfo: "",
                OrganName: "",
                GroupUserId: "",
                UserGroup: null
            },
            // 机构信息
            organData: [],
            // 机构用户组信息
            organLeverData: [],
            organId: "",
            organName: "",
            organLeverId: null,
            organLeverName: "",
            telVisible: false,
            // 步骤条
            active: 1,
            firstStep: true,
            sencendStep: false,
            oldTel: "",
            oldCode: "",
            newTel: "",
            newCode: ""
        };
    },
    methods: {
        updataInfo() {
            this.$refs.navBarLeft.getUserInfo();
        },
        // 基本信息切换
        basicInfo() {
            this.navigationActive = "info";
        },
        // 绑定机构切换
        bindOrgan() {
            this.navigationActive = "organ";
        },
        // 获取用户信息
        async getUserInfo() {
            const { data } = await UserInfo();
            if (data.code === 100) {
                this.userForm = {
                    ID: data.data.userId,
                    UserName: data.data.UserName,
                    RealName: data.data.RealName,
                    Sex: data.data.Gender === "1" ? 1 : 2,
                    Telephone: data.data.Tel,
                    Email: data.data.Email,
                    Address: data.data.Address,
                    CardId: data.data.CardId,
                    NumberNo: data.data.NumberNo,
                    DescInfo: data.data.DescInfo,
                    OrganName: data.data.OrganName,
                    UserGroup: data.data.LevelName
                };
            }
        },
        // 根据关键字获取机构信息
        async GetOrganInfo(organName) {
            const { data } = await GetOrganInfoByKeyword({
                pageSize: 15,
                sortBy: "CreateTime",
                sortOrder: "desc",
                keyWord: organName
            });
            if (data.code === 100) {
                this.organData = data.data;
            }
        },
        // 根据机构id获取用户组信息
        async GetOrganLevelInfo(value) {
            try {
                if (value) {
                    let organObj = {};
                    organObj = this.organData.find((item) => {
                        if (item.ID === value) {
                            this.organName = item.Name;
                        }
                    });
                    this.organId = value;
                    const { data } = await GetOrganLevelInfo({
                        organId: value
                    });
                    if (data.code === 100) {
                        this.organLeverData = data.data;
                    }
                }
            } catch (err) {}
        },
        // 用户组选择事件
        organLeverChange(value) {
            let organLevelObj = {};
            organLevelObj = this.organLeverData.find((item) => {
                if (item.id === value[0]) {
                    this.organLeverName = item.text;
                }
            });

            this.organLeverId = value[0];
        },
        // 编辑用户
        async EditUser() {
            console.log("this.userForm", this.userForm);
            try {
                this.userForm.Sex = 1;
                const { data } = await EditUser(this.userForm);
                if (data.code === 100) {
                    this.$refs.navBarLeft.getUserInfo();
                    this.$message({ message: "保存成功！", type: "success" });
                } else {
                    this.$message({ message: data.msg, type: "error" });
                }
            } catch (err) {
                this.$message({ message: "编辑用户发生异常！", type: "error" });
            }
        },
        // 更新用户组织层级
        async UpdateUserOrganLevel() {
            try {
                const { data } = await UserOrganLevelApply({
                    organId: this.organId,
                    levelId: this.organLeverId
                });
                if (data.code === 100) {
                    this.$message({ message: "申请成功！", type: "success" });
                    this.userForm.OrganName = this.organName;
                    this.userForm.UserGroup = this.organLeverName;
                } else {
                    this.$message({ message: data.msg, type: "error" });
                }
            } catch (err) {
                this.$message({ message: "发生异常！", type: "error" });
            }
        },
        // 获取旧手机验证码
        async GetOldTelphoneCode() {
            try {
                const { data } = await UpdateTelphoneSendMsg({
                    telphone: this.oldTel
                });
                if (data.code === 100) {
                    this.$message({
                        message: "验证码发送成功！",
                        type: "success"
                    });
                } else {
                    this.$message({ message: data.msg, type: "error" });
                }
            } catch (err) {
                this.$message({ message: "发生异常！", type: "error" });
            }
        },
        // 获取新手机验证码
        async GetNewTelphoneCode() {
            try {
                const { data } = await BindTelphoneSendMsg({
                    telphone: this.newTel
                });
                if (data.code === 100) {
                    this.$message({
                        message: "验证码发送成功！",
                        type: "success"
                    });
                } else {
                    this.$message({ message: data.msg, type: "error" });
                }
            } catch (err) {
                this.$message({ message: "发生异常！", type: "error" });
            }
        },
        // 上一步
        prev() {
            this.firstStep = true;
            this.sencendStep = false;
            this.active = 1;
        },
        // 下一步
        async next() {
            try {
                if (!this.oldTel) {
                    this.$message({ message: "请填写手机号！", type: "warn" });
                    return;
                }

                if (!this.oldCode) {
                    this.$message({ message: "请填写验证码！", type: "warn" });
                    return;
                }

                const { data } = await VerifyOldTelphone({
                    telphone: this.oldTel,
                    code: this.oldCode
                });
                if (data.code === 100) {
                    this.firstStep = false;
                    this.sencendStep = true;
                    this.active = 2;
                } else {
                    this.$message({ message: "验证失败！", type: "error" });
                }
            } catch (err) {
                this.$message({ message: "发生异常！", type: "error" });
            }
        },
        // 确认绑定新手机号
        async UpdateTelphone() {
            try {
                if (!this.newTel) {
                    this.$message({ message: "请填写手机号！", type: "warn" });
                    return;
                }

                if (!this.newCode) {
                    this.$message({ message: "请填写验证码！", type: "warn" });
                    return;
                }

                const { data } = await BindTelphone({
                    telphone: this.newTel,
                    code: this.newCode
                });
                if (data.code === 100) {
                    this.$message({ message: "更新成功！", type: "success" });
                    this.getUserInfo();
                    this.CloseDialog();
                } else {
                    this.$message({ message: "绑定失败！", type: "error" });
                }
            } catch (err) {
                this.$message({ message: "发生异常！", type: "error" });
            }
        },
        CloseDialog() {
            this.telVisible = false;
            this.oldTel = "";
            this.oldCode = "";
            this.newTel = "";
            this.newCode = "";
            this.firstStep = true;
            this.sencendStep = false;
            this.active = 1;
        },
        OpenUpdateTel() {
            this.telVisible = true;
            if (!this.userForm.Telephone) {
                this.firstStep = false;
                this.sencendStep = true;
                this.active = 2;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.allContain {
    width: 100%;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 30px;

    .accountSet {
        width: 940px;
        min-height: 830px;
        background-color: white;
        border-radius: 16px;

        .tit {
            padding: 20px 20px 0px 20px;
            box-sizing: border-box;
            border-bottom: 1px solid #e5e8ec;

            .btns {
                height: 35px;
                box-sizing: border-box;
                margin: 0 25px 0 25px;
                cursor: pointer;

                .tab {
                    width: 50px;
                    height: 4px;
                    background: #256cf4;
                    border-radius: 2px;
                }
            }
        }

        .information {
            padding: 20px 30px;
            box-sizing: border-box;

            .line {
                margin-bottom: 30px;

                span {
                    font-size: 16px;
                }

                .header {
                    width: 120px;
                    padding-right: 30px;
                    text-align: right;
                }

                .tab-text {
                    width: 360px;
                }

                // ::v-deep .el-input__inner {
                //   width: 350px;
                //   height: 40px;
                //   font-size: 14px;
                // }

                .bing-line {
                    width: 100%;
                    // height:60px;
                    // line-height: 60px;
                    border-bottom: 1px solid #e5e8ec;
                }
            }

            .saveBtn {
                width: 70px;
                height: 35px;
                background: #256cf4;
                border-radius: 4px;
                color: white;
                cursor: pointer;
            }

            .fristLine {
                margin-top: 20px;
            }
        }
    }

    ::v-deep .el-dialog__body {
        border-top: 1px solid #dcdfe6;
        padding: 0;
        text-align: center;
        font-size: 12px;
    }

    ::v-deep .el-dialog__footer {
        height: 50px;
        border-top: 1px solid #dcdfe6;
        margin-top: 30px;
    }

    .dialog-step {
        width: 500px;
        height: 70px;
        padding-top: 20px;

        ::v-deep .el-step__title {
            font-size: 12px;
        }
    }

    .dialog-div {
        padding: 20px 0 20px 0;

        .dialog-div-p {
            width: 120px;
            text-align: right;
            float: left;
        }
        .dialog-text {
            width: 300px;
            height: 30px;
            margin-left: -30px;
        }

        .dialog-text-code {
            width: 200px;
            height: 30px;
            margin-left: -30px;
        }

        .dialog-codebtn {
            width: 80px;
            font-size: 12px;
            margin-left: 20px;
            padding: 12px 10px;
        }
    }
}
</style>
